<template>
  <div class="container-fluid">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px"
      >
        <h2 style="flex: 1">Device Expiry Report</h2>
      </div>
      <div class="main-container device-expiry-table-height">
        <el-input
          style="max-width: 200px"
          placeholder="Type something"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
        ></el-input>
        <vue-good-table
          :lineNumbers="true"
          :columns="fields"
          :rows="getDevices"
          :select-options="selectOption"
          :search-options="{
            enabled: true,
            searchFn: searchTable,
            externalQuery: searchTerm
          }"
          :pagination-options="{ enabled: true }"
        >
          <template slot="table-row" slot-scope="props" style="background: red;">
            <span v-if="props.column.field == 'remoteExpiryDate'">
              <span v-if="props.row.remoteExpiryDate">
              {{ props.row.remoteExpiryDate | formatDate }}
              </span>
              <span v-else>--</span>
            </span>
            <span v-if="props.column.field == 'expiryDate'"
              ><span v-if="props.row.expiryDate">
                {{ props.row.expiryDate | formatDate }}
              </span>
              <span v-else>--</span>
            </span>
            <span v-if="props.column.field == 'lastSyncTime'">
              <span v-if="props.row.lastSyncTime">
                {{ props.row.lastSyncTime | formatDateTime }}
              </span>
              <span v-else>--</span>
            </span>
            <span v-if="props.column.field == 'deviceId'">{{
              props.row.deviceId ? props.row.deviceId : "-"
            }}</span>
            <span v-if="props.column.field == 'customerName'">{{
              props.row.customerName ? props.row.customerName : "-"
            }}</span>
            <span  v-if="props.column.field == 'isShutdown'">
            <i class="fas fa-lightbulb fa-2x"  v-bind:style="props.row.isShutdown ? 'color: red' : 'color: green'" aria-hidden="true"></i>
            </span>
            <span v-if="props.column.field == 'syncStatus'">
            <i class="fas fa-sync fa-2x"
                  v-bind:style="(
                  (props.row.remoteExpiryDate && props.row.remoteExpiryDate.substring(0,10)) === 
                  (props.row.expiryDate && props.row.expiryDate.substring(0,10)))
                    ? 'color: green' : 'color: red'"></i>
            </span>
            <span v-if="props.column.field == 'adminPower'">{{
              // props.row.adminPower ? props.row.adminPower : "-"
              // adminPowerCast(props.row.adminPower) ? props.row.adminPower : "-"
              adminPowerCast(props.row.adminPower)
            }}</span>
            <span  v-if="props.column.field == 'actions'">
              <b-button variant="success" @click.stop="toggleEditCanvas( props.row)">Extend Expiry Date</b-button>
            </span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>
    </div>
    <vk-offcanvas flipped overlay stuck :show.sync="editOffCanvas">
      <div style>
        <vk-offcanvas-close @click="editOffCanvas = false"></vk-offcanvas-close>
        <h3>Extend Device Admin Shutdown</h3>
        <hr />
        <el-form
          class="form"
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item class="form-item" label="Invoice Number">
            <el-input
              style="width: 100%"
              id="customer-name"
              v-model="regDataParams.invoiceNumber"
              :min="1"
            ></el-input>
          </el-form-item>

         <el-form-item style="text-align: center;" class="form-item" label="Payment From">
           <el-date-picker
             disabled
             v-model="regDataParams.oldExpiryDate"
             type="date"
             style="width: 100%"
           >
            </el-date-picker>
         </el-form-item>

         <el-form-item style="text-align: center;" class="form-item" label="Expiry Date">
           <el-date-picker
             v-model="regDataParams.newExpiryDate"
             type="date"
             style="width: 100%"
           >
            </el-date-picker>
         </el-form-item>

          <el-form-item>
            <el-button
              type="prim​​ary"
              class="customer-btn"
              @click="onSubmit()"
              >{{ isLoading ? "Loading..." : "Submit" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </vk-offcanvas>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      searchTerm: "",
      editOffCanvas: false,
      isLoading: false,
      regDataParams: {
        name
      },
      selectOption: {
        enabled: false
      },
      items: items,
      fields: [
        {
          field: "customerName",
          label: "Customer Name",
          sortable: "true",
          tdClass: 'text-center',
        },
        {
          field: "deviceId",
          label: "Device Id",
          sortable: "true"
        },
        {
          field: "expiryDate",
          label: "Local Expiry Date",
          sortable: "true"
        },
        {
          field: "remoteExpiryDate",
          label: "Remote Expiry Date",
          sortable: "true"
        },
        {
          field: "lastSyncTime",
          label: "Last Sync Time",
          sortable: "true"
        },
        {
          field: "isShutdown",
          label: "Admin Power",
          sortable: "true",
          tdClass: 'text-center'
        },
        {
          field: "syncStatus",
          label: "Sync Status",
          sortable: "true",
          tdClass: 'text-center',
        },
        {
          field: "adminPower",
          label: "Device Status",
          sortable: "true",
          tdClass: 'text-center',
        },
        // {
        //   field: "actions",
        //   label: "Actions",
        //   sortable: "false"
        // }
      ],
      getDevices: "",
      currentPage: 0,
      details: "UserDetails",
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          {
            field: '',
            type: ''
          }
        ],
        perPage: 200,
        page: 1
      },
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  computed: {
    ...mapGetters(["getUserById", "getDummy", "getUserSession"]),
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    onSubmit() {
      const ConfigurationHTTP = this.$httpUtils.NotificationHTTP;
      var container = this;
      let { deviceId, invoiceNumber, newExpiryDate } = container.regDataParams;

      if (!invoiceNumber || !newExpiryDate) {
        this.showErrorMsg({
          message: "Fill in all fields"
        });

        return;
      };
      this.toggleIsLoading();
      let url = `/${deviceId}`;
      ConfigurationHTTP.patch(url, { expiryDate: newExpiryDate })
        .then(_ => {
          this.toggleIsLoading();
          container.regSuccess = true;
          this.showSuccessMsg({
            message: "Expiry Date Updated!"
          });
          this.loadItems();
          this.editOffCanvas = false;

          this.regDataParams = {
            name: ""
          };
        })
        .catch(error => {
          this.toggleIsLoading();
          if (error.response.data.error.details) {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = Object.keys(errorMsg);
            Object.values(errorMsg).map((x, index) => {
              errTemp[index] = keyHooks[index] + " " + x[0];
            });
            errTemp = Object.values(errTemp).join("<br>");
            this.showErrorMsg({
              message: errTemp
            });
          } else {
            this.showErrorMsg({
              message: error.response.data.error.message
            });
          }
        });
    },
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    toggleEditCanvas(data) {
      this.regDataParams = {...data, oldExpiryDate: data.expiryDate, newExpiryDate: moment(data.expiryDate).add(1, 'month').format('YYYY-MM-DD')};
      this.editOffCanvas = !this.editOffCanvas;
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    navTo(deviceId) {
      this.$router.push({
        // path: `/device/${deviceId}`,
        name: "viewDevices",
        params: {
          deviceId: deviceId,
          activetab: "maintenance"
        }
      });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    init() {
      const httpUtils = this.$httpUtils;
      let userId = this.getUserSession.id;
      let realm = this.getUserSession.realm;

    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    loadItems() {
      const httpUtils = this.$httpUtils;
      httpUtils.NotificationHTTP.get(`?pageIndex=${this.serverParams.page}&pageSize=${this.serverParams.perPage}`)
        .then(response => {
          this.getDevices = response.data.response.items;
          this.rows = response.data.response.items;
          this.totalRecords = response.data.response.count;
        })
        .catch(error => {
          this.errors = "Error occured at our end!";
          this.getDevices = "";
        });
    },
    adminPowerCast(data) {
      if ( typeof data === 'undefined' || data === null ){
        return "--"
      }else if (data.includes("1111")) {
        return "Device Online"
      }else if (data.includes("A")) {
        return "Admin Shut-Down"
      }else if (data.includes("B")) {
        return "Battery Low"
      }else if (data.includes("E")) {
        return "Expiry Date Shut-Down"
      }else if (data.includes("U")) {
        return "User Shut-Down"
      }else {
        return "--"
      }
    },
  },
  async mounted() {
    this.init();
    this.loadItems();
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
.device-expiry-table-height {
  height: calc(100vh - 240px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/devices/Devices.vue